import { useEffect, useRef } from 'react';
/**
 * Normalizes a forwarded ref into a ref object.
 * @param ref Forwarded ref.
 */
export function useForwardedRef(ref) {
    const mutableRef = useRef(null);
    useEffect(() => {
        if (typeof ref === 'function')
            ref(mutableRef.current);
        else if (ref)
            ref.current = mutableRef.current;
    }, []);
    return mutableRef;
}
//# sourceMappingURL=useForwardedRef.js.map